/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light (1–3 days/week)`)
};

const es_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligero (1–3 días/semana)`)
};

const de_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leicht (1–3 Tage/Woche)`)
};

const nl_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licht (1–3 dagen/week)`)
};

const fr_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Léger (1-3 jours/semaine)`)
};

const it_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggero (1–3 giorni/settimana)`)
};

const pt_br2_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leve (1–3 dias/semana)`)
};

const pt_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leve (1–3 dias/semana)`)
};

const ja_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`軽度（週1～3日）`)
};

const zh_bmr_act_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轻度（每周 1–3 天）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_act_light = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_act_light(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_act_light", locale)
	if (locale === "en") return en_bmr_act_light(inputs)
	if (locale === "es") return es_bmr_act_light(inputs)
	if (locale === "de") return de_bmr_act_light(inputs)
	if (locale === "nl") return nl_bmr_act_light(inputs)
	if (locale === "fr") return fr_bmr_act_light(inputs)
	if (locale === "it") return it_bmr_act_light(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_act_light(inputs)
	if (locale === "pt") return pt_bmr_act_light(inputs)
	if (locale === "ja") return ja_bmr_act_light(inputs)
	return zh_bmr_act_light(inputs)
};